module.exports = __webpack_public_path__ + "media/images/favicon-2fe3198c021fbb85b37488bfa69e8582.ico";